var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-wrapper"},[_c('div',{staticClass:"main-scroll"},[_c('nav-com',{attrs:{"flag":_vm.flag}}),_c('resume-com'),_c('foot-com',{staticClass:"foots"})],1),_c('bottom-backtop')],1)}
var staticRenderFns = []

export { render, staticRenderFns }